export default {
  companies: [],
  id: null,
  company: null,
  parent: null,
  isWizardCompleted: false,
  loading: false,
  categories: [],
  data: {}
};
